<ng-container *transloco="let t">
    <form class="layout" [formGroup]="form" (ngSubmit)="submitForm()">
        <div class="file-section form-group">
            <label for="file">
                {{
                    t(
                        "Reference document label (from document template) - Reference Document"
                    )
                }}
                <span class="text-danger">*</span>
            </label>
            <app-drop-file-input
                class="file-upload"
                formControlName="file"
                [maxFileSize]="10 * 1024 * 1024"
            ></app-drop-file-input>
            <!-- Error message for file -->
            <div *ngIf="isFileInvalid" class="invalid-feedback d-block">
                {{
                    t(
                        "File upload error message (from document template) - Please upload a document to convert"
                    )
                }}
            </div>
        </div>
        <div class="instructions-section form-group">
            <label for="prompt">
                {{
                    t(
                        "Additional instructions label (from document template) - Additional Instructions Optional"
                    )
                }}
            </label>
            <div class="form-group">
                <textarea
                    formControlName="prompt"
                    type="text"
                    [placeholder]="
                        t(
                            'Instructions placeholder (from document template) - Any specific instructions for template generation'
                        )
                    "
                    class="form-control"
                    rows="3"
                >
                </textarea>
            </div>
        </div>
    </form>
</ng-container>
